import { useState } from "react";
import { Card } from "react-bootstrap";
import DataTable from "../table/DataTable";
import { DENOMINATIONS } from "./constant";

const Cash = () => {
  const [quantities, setQuantities] = useState({
    bill100: 0,
    bill50: 0,
    bill20: 0,
    bill10: 0,
    bill5: 0,
    bill1: 0,
    coin1: 0,
    coin50c: 0,
    coin25c: 0,
    coin10c: 0,
    coin5c: 0,
    coin1c: 0,
  });

  const handleQuantityChange = (id, val) => {
    const numVal = parseInt(val) || 0;
    setQuantities((prev) => ({ ...prev, [id]: numVal }));
  };

  const calculateTotal = () => {
    return DENOMINATIONS.reduce((acc, curr) => {
      return acc + curr.value * (quantities[curr.id] || 0);
    }, 0);
  };

  const columns = [
    {
      label: "IMAGE",
      key: "image",
      render: (item) => (
        <div 
          className="d-flex align-items-center justify-content-center border rounded bg-light"
          style={{ width: "60px", height: "40px", overflow: "hidden" }}
        >
          {item.image ? (
            <img src={item.image} alt={item.label} style={{ width: "100%", height: "auto" }} />
          ) : (
            <div 
              className="rounded-circle d-flex align-items-center justify-content-center text-muted fw-bold"
              style={{ 
                width: "30px", 
                height: "30px", 
                backgroundColor: item.id === "coin1" ? "#FFD700" : "#E0E0E0",
                fontSize: "10px",
                border: "1px solid #ccc"
              }}
            >
              C
            </div>
          )}
        </div>
      )
    },
    {
      label: "DENOMINATION",
      key: "label",
      render: (item) => <span className="fw-bold">{item.label}</span>
    },
    {
      label: "QUANTITY",
      key: "quantity",
      render: (item) => (
        <input
          type="number"
          className="form-control text-center bg-transparent border-0"
          style={{ width: "80px", color: quantities[item.id] > 0 ? "#000" : "#ccc" }}
          value={quantities[item.id] || ""}
          placeholder="--"
          onChange={(e) => handleQuantityChange(item.id, e.target.value)}
        />
      ),
      cellClassName: "text-center"
    },
    {
      label: "TOTAL",
      key: "total",
      render: (item) => {
        const rowTotal = item.value * (quantities[item.id] || 0);
        return (
          <span className="fw-bold">
            $
            {rowTotal.toLocaleString(undefined, {
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
            })}
          </span>
        );
      },
      cellClassName: "text-end pe-4",
    },
  ];

  return (
    <div className="container-fluid">
      <div className="d-flex align-items-center mb-4">
        <h3 className="fw-bold text-black mb-0 me-2">Cash - US Dollar</h3>
        <i className="fas fa-chevron-down text-muted cursor-pointer"></i>
      </div>

      <Card className="border-0 shadow-sm rounded-4 overflow-hidden">
        <Card.Body className="p-0">
          <DataTable
            data={DENOMINATIONS}
            columns={columns}
            showPagination={false}
            minWidth="100%"
          />
          <div 
            className="d-flex justify-content-between align-items-center p-4 bg-light"
            style={{ borderTop: "1px solid #eee" }}
          >
            <span className="fw-bold fs-16 text-black">Total:</span>
            <span className="fw-bold fs-18" style={{ color: "#00264D" }}>
              ${calculateTotal().toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })}
            </span>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default Cash;
